import React from "react";
import { useMessageSource } from "react-message-source";
import TextInputField from "../formik/text-input";

export default function Email({
  forceReRender,
  name,
  dataPath = "",
  value,
  isPrivate = true,
  disabled = false,
  helperUnderInput,
}: {
  forceReRender?: boolean;
  name?: string;
  dataPath?: string;
  value: string;
  isPrivate?: boolean;
  disabled?: boolean;
  helperUnderInput?: string;
}): React.JSX.Element {
  const { getMessage } = useMessageSource();

  const emailKeyAndNameSelector = `email${isPrivate ? "Private" : "Business"}`;

  return (
    <TextInputField
      forceReRender={forceReRender}
      name={name || `${dataPath}${emailKeyAndNameSelector}`}
      label={getMessage(`Person.${emailKeyAndNameSelector}`)}
      value={value}
      disabled={disabled}
      helperUnderInput={helperUnderInput}
      type="email"
    />
  );
}
